import { apiFetch } from './client';

// Public notice page client — no auth; the token in the URL is the credential
// (mirrors billing_public / membercards_public). Only safe-to-expose fields.

export interface PublicNotice {
  member_name: string;
  team_name: string;
  period?: string;
  season?: string;
  year?: number;
  state: string;
  currency?: string;
  total_minor: number;
  membership_minor: number;
  training_minor: number;
  addon_minor: number;
  due_date?: string;
  is_tryout: boolean;
  self_dereg_enabled: boolean;
  self_dereg_label?: string;
}

export async function getPublicNotice(token: string): Promise<PublicNotice> {
  return apiFetch<PublicNotice>(`/api/v1/public/notices/${encodeURIComponent(token)}`);
}

export async function publicDeregister(
  token: string,
  body: { reason?: string; comment?: string },
): Promise<void> {
  await apiFetch<void>(`/api/v1/public/notices/${encodeURIComponent(token)}/deregister`, {
    method: 'POST',
    body,
  });
}
